const CryptoJS = require("crypto-js");

const md5 = require('md5');

export default {
  encrypt(data, keyCode, ivCode) {
    const key = CryptoJS.enc.Utf8.parse(keyCode || 'sd7JD8sKzc8MHdf8');
    const iv = CryptoJS.enc.Utf8.parse(ivCode || '29JlOd8SCdk82CFd');
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });
    return `${encrypted}`;
  },

  decrypt(data, keyCode, ivCode) {
    const key = CryptoJS.enc.Utf8.parse(keyCode || 'sd7JD8sKzc8MHdf8');
    const iv = CryptoJS.enc.Utf8.parse(ivCode || '29JlOd8SCdk82CFd');
    const decrypted = CryptoJS.AES.decrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  },

  md5Pass(pass, salt) {
    const temp = `${pass}&${salt}`;
    return md5(temp).toLowerCase().slice(-26);
  },

  tripleDES(pass, secret) {
    const key = CryptoJS.enc.Utf8.parse(secret);
    const encrypted = CryptoJS.TripleDES.encrypt(pass, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
    return CryptoJS.enc.Base64.parse(encrypted).toString();
  }

};